<template>
    <div class="elementary-section">
        <div class="elementary-section__in">
            <div class="container">
                <img src="/assets/images/layout/city.svg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MainContainer'
}
</script>
